module.exports = __webpack_public_path__ + "img/fake-user-6.961fbf74.png";